import React from "react";

interface SectionHeaderProps {
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  return (
    <div className="flex items-center gap-2 mb-3">
      <div className="h-px flex-1 bg-gradient-to-r from-gray-200 to-transparent"></div>
      <span className="text-xs font-semibold text-[#885ABB] uppercase tracking-wider">
        {title}
      </span>
      <div className="h-px flex-1 bg-gradient-to-l from-gray-200 to-transparent"></div>
    </div>
  );
};

export default SectionHeader;
